import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { colors } from "../../../utils/colors";
import { ArrowRight } from "../../atoms/Icons/ArrowRight";

const Wrapper = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    border: 1.5px solid ${colors.brandMid};
    border-radius: 10px;
    font-size: 16px;
    line-height: 1;
    text-decoration: none;
    transition: 100ms ease all;
    font-weight: 500;
    min-height: 65px;

    [data-whatintent="mouse"] &:hover {
        background-color: ${colors.brandMid};
        color: white;
    }
`;

export const ConditionCard = (props: { title: string; to: string }) => {
    return (
        <Wrapper to={props.to}>
            {props.title}
            <ArrowRight style={{ marginLeft: 10 }} />
        </Wrapper>
    );
};
